import { appConfig } from "../../system/types/app/appConfig";
import {SYSTEM_ACTIONS} from "./types";

export const systemToggleDarkTheme = () => {
    return {
        type: SYSTEM_ACTIONS.systemToggleDarkTheme,
    };
};


export const systemSetAppConfig = (appConfig: appConfig) => {
    return {
        type: SYSTEM_ACTIONS.systemSetAppConfig,
        payload: appConfig,
    };
};

export const systemSetInitDone = (isDone: boolean) => {
    return {
        type: SYSTEM_ACTIONS.systemSetInitDone,
        payload: isDone,
    }
}
